import React from "react";

const EmailForm = ({ formValues, setFormValues, formErrors, isStaff }) => {
  const handleActionChange = (action) => {
    setFormValues((prev) => ({
      ...prev,
      action: prev.action === action ? "" : action,
    }));
  };

  return (
    <div className="pp-approval-actions-section">
      <label className="pp-approval-section-label">
        Review Decision <span className="pp-approval-required">*</span>
      </label>

      <p className="pp-approval-section-description">
        Please review the payroll details above and choose your decision. This
        action will be recorded and cannot be undone.
      </p>

      <div className="pp-approval-actions-group">
        <button
          type="button"
          className={`pp-approval-action-btn approve ${
            formValues.action === "approve" ? "selected" : ""
          }`}
          onClick={() => handleActionChange("approve")}
        >
          <span className="pp-approval-action-icon">✓</span>
          {isStaff ? "Review Done" : "Approve"}
        </button>

        <button
          type="button"
          className={`pp-approval-action-btn reject ${
            formValues.action === "reject" ? "selected" : ""
          }`}
          onClick={() => handleActionChange("reject")}
        >
          <span className="pp-approval-action-icon">✗</span>
          {isStaff ? "Create Discrepancy" : "Reject"}
        </button>
      </div>

      {formErrors?.action && (
        <span className="pp-approval-error">{formErrors.action}</span>
      )}
    </div>
  );
};

export default EmailForm;
